export default __webpack_public_path__ + "static/media/left_bcr.7e0f709f.svg";